/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box, Button } from "@mui/material";
import LoadingIndicator from "../../../../Basis/Components/LoadingIndicator";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nEinstellungen";
import { useSchnelleinstiegContext } from "./SchnelleinstiegContext";
import SchrittHeader from "./SchrittHeader";
import SchrittText from "./SchrittText";
import SchrittTitel from "./SchrittTitel";

export default function SchnelleinstiegStripe() {
    const { stripe } = useSchnelleinstiegContext();
    const [disabled, setDisabled] = React.useState(false);
    const { t } = useTranslation();

    if (stripe.kontoResult.loading) {
        return <LoadingIndicator loading />
    }

    const stripeKonto = stripe.kontoResult.data;

    return (
        <>
            <SchrittHeader>
                <SchrittTitel>
                    {t(translationKeys.schnelleinstiegStripe.titel)}
                </SchrittTitel>
            </SchrittHeader>

            <Box sx={{ mr: "34.39px" }}>
                <SchrittText>{t(translationKeys.schnelleinstiegStripe.text)}</SchrittText>

                <div>
                    <Button
                        sx={{ display: "block", ml: "auto" }}
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            try {
                                setDisabled(true);
                                if (stripeKonto === null) {
                                    await stripe.service.kontoVerknuepfen();
                                }

                                const currentUrl = window.location.href;
                                const kontoLink = await stripe.service.kontoLinkErstellen(currentUrl, currentUrl);
                                window.location.href = kontoLink.url;
                            } catch {
                                setDisabled(false);
                            }
                        }}
                        disabled={disabled}
                    >
                        {t(translationKeys.schnelleinstiegStripe.stripeVerknuepfen)}
                    </Button>
                </div>
            </Box>
        </>
    )
}